import { UserManager } from 'oidc-client-ts';
import { useContainer } from '.';

export const useUserManager = (): UserManager => useContainer().userManager;
